<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>{{ $route.meta.name }}管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.name }}列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel" v-if="order.id">
      <el-page-header @back="$router.go(-1)" content="订单详情">
      </el-page-header>
      <el-descriptions title="" size="small" border>
        <el-descriptions-item label="新旧钻头">
          {{ order.is_drill_new == 2 ? '旧钻头' : '新钻头' }}
        </el-descriptions-item>
        <template v-if="order.is_drill_new == 2">
          <el-descriptions-item label="序列号">
            <DrillLink :no="order.old_drill_serial_number"></DrillLink>
          </el-descriptions-item>
          <el-descriptions-item label="维修基地">
            {{ order.fix_base_name }}
          </el-descriptions-item>
        </template>
        <el-descriptions-item label="钻头类型">
          {{ order.drill_type_name }}
        </el-descriptions-item>
        <el-descriptions-item label="规格">
          {{ order.drill_size }}
        </el-descriptions-item>
        <el-descriptions-item label="型号">
          {{ order.model_number }}
        </el-descriptions-item>
        <el-descriptions-item label="零件号">
          {{ order.component_number }}
        </el-descriptions-item>
        <el-descriptions-item label="数量">
          {{ order.drill_number }}
        </el-descriptions-item>
        <el-descriptions-item label="使用区块">
          {{ order.block_info }}
        </el-descriptions-item>
        <el-descriptions-item label="下料">
          {{ order.cut_info }}
        </el-descriptions-item>
        <el-descriptions-item class="mar-top" label="交货紧急程度">
          {{ order.urgent_level_info }}
        </el-descriptions-item>
        <el-descriptions-item label="销售类型">
          {{ order.sale_type_info }}
        </el-descriptions-item>
        <el-descriptions-item v-if="order.is_drill_new == 2" label="维修方案">
          {{ order.fix_plan_type }}
        </el-descriptions-item>
        <el-descriptions-item label="敷焊条">
          {{ order.welding_rod }}
        </el-descriptions-item>
        <el-descriptions-item label="喷嘴安装方式">
          {{ order.nozzle_install_info }}
        </el-descriptions-item>
        <el-descriptions-item label="喷嘴">
          {{ order.nozzle }}
        </el-descriptions-item>
        <el-descriptions-item label="包装">
          {{ order.package_type_info }}
        </el-descriptions-item>
        <el-descriptions-item class="mar-top" label="备注">
          {{ order.remark }}
        </el-descriptions-item>
        <template v-if="order.status > 3">
          <el-descriptions-item class="mar-top" label="外协厂家">
            {{ order.factory.name }}
          </el-descriptions-item>
          <el-descriptions-item label="交货时间">
            {{ order.deliver_time }}
          </el-descriptions-item>
        </template>
        <el-descriptions-item label="状态 / 进度">
          {{ order.option_status_name }} / {{ order.status_name }}
        </el-descriptions-item>
      </el-descriptions>
      <div class="mt-10" v-if="order.option_status == 1">
        <btn-tag
          :btn="true"
          text="负责人审核"
          :key="Math.random()"
          btn-class="btn-info"
          :auth-id="32109"
          module-name="orders"
          @click.native="hanldeUpdate(7)"
          v-if="order.status == 1 && order.principals.includes(userInfo.id)"
        ></btn-tag>
        <btn-tag
          :btn="true"
          text="技术确认"
          :key="Math.random()"
          :auth-id="32103"
          btn-class="btn-info"
          module-name="orders"
          @click.native="hanldeUpdate(2)"
          v-if="order.status == 7"
        ></btn-tag>
        <btn-tag
          :btn="true"
          text="领导审批"
          :key="Math.random()"
          :auth-id="32104"
          btn-class="btn-info"
          module-name="orders"
          @click.native="hanldeUpdate(3)"
          v-if="order.status == 2"
        ></btn-tag>
        <btn-tag
          :href="'/orders/' + order.id + '/factory'"
          text="填写外协商厂家"
          :key="Math.random()"
          :auth-id="32105"
          btn-class="btn-info"
          module-name="orders"
          v-if="order.status == 3"
        ></btn-tag>
        <btn-tag
          :btn="true"
          text="模型发送确认"
          :key="Math.random()"
          :auth-id="32107"
          btn-class="btn-info"
          module-name="orders"
          @click.native="hanldeUpdate(4)"
          v-if="order.status == 4 && order.principals.includes(userInfo.id)"
        ></btn-tag>
      </div>
    </div>
    <div class="panel">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="包含钻头" name="tab1">
          <el-table border :data="drills">
            <el-table-column label="序列号" align="center">
              <template slot-scope="scope">
                <DrillLink :no="scope.row.serial_number"></DrillLink>
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <span
                  class="label"
                  :class="
                    scope.row.status == 1 ? 'label-success' : 'label-warning'
                  "
                  >{{ scope.row.status == 1 ? '已到达' : '未到达' }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <btn-tag
                  :btn="true"
                  text="确认到达"
                  :key="scope.$index"
                  :auth-id="32106"
                  btn-class="btn-info"
                  icon-class="ion-checkmark-round"
                  module-name="orders"
                  @click.native="hanldeReceive(scope.row, scope.$index)"
                  v-if="scope.row.status == 0 && order.option_status == 1"
                ></btn-tag>
                <a
                  v-if="scope.row.status == 1"
                  :href="`/products/${scope.row.serial_number}`"
                  target="_blank"
                  class="btn btn-sm btn-labeled btn-rounded btn-info"
                >
                  <i class="btn-label ion-information-circled"></i>
                  生产详情
                </a>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="操作记录" name="tab2">
          <div class="timeline">
            <!-- Timeline header -->
            <!-- <div class="timeline-header">
					                <div class="timeline-header-title bg-success">Now</div>
                  </div>-->
            <div class="timeline-entry" v-for="item in logs" :key="item.id">
              <div class="timeline-stat">
                <div class="timeline-icon">
                  <img src="../../../assets/images/avatar.png" alt="Image" />
                </div>
                <div class="timeline-time">
                  {{ $time(item.created_at).format('YYYY-MM-DD HH:mm') }}
                </div>
              </div>
              <div class="timeline-label">
                <p class="text-main text-semibold">
                  <span class="text-info">{{ item.user_name }}</span>
                  {{ item.category_name }}
                </p>
                <span v-html="item.content" v-if="item.content"></span>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import {
  orderShow,
  orderDrillReceive,
  orderLaunch,
  orderChiefCheck,
  orderCheck,
  orderApprove,
  orderModelSendCheck,
  orderAddInvoice,
} from '@/service/getData'
import { getStore } from '@/config/mUtils'
import upload from '../../../components/upload.vue'
export default {
  components: {
    upload,
  },
  data() {
    return {
      activeTab: 'tab1',
      order: {},
      logs: [],
      drills: [],
      userInfo: getStore('userInfo'),
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      let id = this.$route.params.id
      if (id) {
        let res = await orderShow(id)
        res.data.invoices = res.data.invoices || []
        this.order = res.data
        this.logs = res.data.order_logs
        if (this.order.status > 4) {
          this.drills = res.data.drills
        }
      }
    },
    hanldeUpdate(status) {
      let that = this
      let data = { id: this.order.id }
      var confirmText = status == 4 ? '确认已发送模型吗？' : '确认审核通过吗？'
      var cancelText = status == 4 ? '取消' : '打回'
      that.$dialog
        .confirm(confirmText, {
          cancelText: cancelText,
        })
        .then(function (dialog) {
          data.pass = true
          switch (status) {
            case 7:
              orderChiefCheck(data).then((res) => {
                if (res.status == 0) {
                  that.initData()
                }
              })
              break
            case 1:
              orderLaunch(data).then((res) => {
                if (res.status == 0) {
                  that.initData()
                }
              })
              break
            case 2:
              orderCheck(data).then((res) => {
                if (res.status == 0) {
                  that.initData()
                }
              })
              break
            case 3:
              orderApprove(data).then((res) => {
                if (res.status == 0) {
                  that.initData()
                }
              })
              break
            case 4:
              orderModelSendCheck(data).then((res) => {
                if (res.status == 0) {
                  that.initData()
                }
              })
          }
        })
        .catch(function () {
          data.pass = false
          switch (status) {
            case 7:
              orderChiefCheck(data).then((res) => {
                if (res.status == 0) {
                  that.$dialog.alert('打回成功')
                  that.initData()
                }
              })
              break
            case 2:
              orderCheck(data).then((res) => {
                if (res.status == 0) {
                  that.$dialog.alert('打回成功')
                  that.initData()
                }
              })
              break
            case 3:
              orderApprove(data).then((res) => {
                if (res.status == 0) {
                  that.$dialog.alert('打回成功')
                  that.initData()
                }
              })
              break
          }
        })
    },
    hanldeReceive(item, index) {
      let that = this
      let data = {
        id: that.order.id,
        drill_id: item.id,
      }
      that.$dialog.confirm('确认到达吗').then(function (dialog) {
        orderDrillReceive(data).then((res) => {
          if (res.status == 0) {
            that.logs = res.data.order_logs
            that.drills = res.data.drills
          }
        })
      })
    },
    async hanldeAddInvoice() {
      let data = {
        id: this.order.id,
        invoices: this.order.invoices.map((item) => {
          return { name: item.name, path: item.path }
        }),
      }
      let res = await orderAddInvoice(data)
      if (res.status == 0) {
        this.initData()
      }
    },
  },
}
</script>

<style scoped>
span.text-semibold {
  margin-right: 10px;
  width: 20%;
  display: inline-block;
  text-align: right;
}
.option-btn {
  /* display: flex; */
  /* justify-content: flex-end; */
  /* margin-top: -20px; */
  float: right;
}
</style>